(function () {
  function init(root) {
    if (!root || root.dataset.twiglioWholesaleReady === 'true') return;
    root.dataset.twiglioWholesaleReady = 'true';

    root.querySelectorAll('a[target="_blank"]').forEach(function (link) {
      link.rel = 'noopener noreferrer';
    });

    root.querySelectorAll('#catalog th.sortable').forEach(function (th) {
      function sortColumn() {
        var table = th.closest('table');
        var tbody = table.querySelector('tbody');
        var rows = Array.from(tbody.querySelectorAll('tr'));
        var col = Number(th.dataset.col);
        var type = th.dataset.type;
        var asc = th.dataset.dir !== 'asc';

        table.querySelectorAll('th.sortable').forEach(function (header) {
          header.dataset.dir = '';
          header.setAttribute('aria-sort', 'none');
        });
        th.dataset.dir = asc ? 'asc' : 'desc';
        th.setAttribute('aria-sort', asc ? 'ascending' : 'descending');

        rows.sort(function (a, b) {
          var av = a.children[col].dataset.sort || a.children[col].textContent.trim();
          var bv = b.children[col].dataset.sort || b.children[col].textContent.trim();
          if (type === 'number') {
            av = parseFloat(av);
            bv = parseFloat(bv);
            return asc ? av - bv : bv - av;
          }
          return asc ? av.localeCompare(bv) : bv.localeCompare(av);
        });
        rows.forEach(function (row) { tbody.appendChild(row); });
      }

      th.addEventListener('click', sortColumn);
      th.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          sortColumn();
        }
      });
    });

    root.querySelectorAll('[data-partner-carousel]').forEach(function (carousel) {
      var viewport = carousel.querySelector('[data-partner-carousel-viewport]');
      var previousButton = carousel.querySelector('[data-partner-carousel-prev]');
      var nextButton = carousel.querySelector('[data-partner-carousel-next]');

      if (!viewport || !previousButton || !nextButton) return;

      function scrollCarousel(direction) {
        var card = viewport.querySelector('.partner-design-card');
        var styles = window.getComputedStyle(viewport);
        var gap = parseFloat(styles.columnGap || styles.gap) || 0;
        var cardWidth = card ? card.getBoundingClientRect().width : viewport.clientWidth;
        var cardsPerStep = window.matchMedia('(max-width: 749px)').matches ? 1 : 2;

        viewport.scrollBy({
          left: direction * (cardWidth + gap) * cardsPerStep,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      }

      previousButton.addEventListener('click', function () { scrollCarousel(-1); });
      nextButton.addEventListener('click', function () { scrollCarousel(1); });
    });

    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
      var sections = Array.from(root.querySelectorAll('.wholesale-main > section:not(.hero)'));
      root.classList.add('motion-ready');
      sections.forEach(function (section) { section.classList.add('reveal'); });
      var revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      sections.forEach(function (section) { revealObserver.observe(section); });
      window.setTimeout(function () {
        sections.forEach(function (section) { section.classList.add('is-visible'); });
      }, 1800);
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-twiglio-wholesale]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
}());
